<template>
  <div :class="`subscribe-dialog ${bg||''}`">
      <img class="wow" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/guitar-wow.png"/>
      <img class="banner" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/subscribe/subscribe-banner.png"/>
      <div class="content">
        <img class="qr-code" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/wx-subscribe.jpg"/>
        <p class="p1">长按识别关注</p>
        <p class="p2">（如无法识别请保存到手机识别）</p>
      </div>
      <img class="close-btn" @click="hideDialog" src="https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/subscribe/close-btn.png"/>
    </div>
</template>
<script>
export default {
  props:['bg'],
  methods:{
    hideDialog(){
      this.$emit('close');
    }
  }
}
</script>
<style lang="scss" scoped>
.subscribe-dialog{
  position: fixed;
  top:0;
  left:0;
  bottom:0;
  right:0;
  z-index: 1000000;
  background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/game/bg.png);
  background-position: center top;
  background-size: 100% 100%;
  text-align: center;
  overflow: hidden;
  &.bg1{
    background-image: url(https://wowsite.musicwow.com/mobile_musicwow/image/activity/6th/draw/new-draw-bg2.png)!important;
  }
  .wow{
    width: 123px;
    height: auto;
    margin-top:10px;
  }
  .banner{
    width: 255px;
    height: auto;
    margin-top: -40px;
  }
  .content{
    background: rgba(0, 78, 44, 0.55);
    border: 2px solid rgba(255, 255, 255, 1);
    margin: -40px 18px 0 18px;
    border-radius: 30px;
    padding:60px 55px;
    .qr-code{
      width: 226px;
      height: 226px;
      margin-bottom: 20px;
    }
    .p1{
      font-size: 14px;
      line-height: 14px;
      color: #fff;
      margin-bottom: 12px;
    }
    .p2{
      font-size: 14px;
      line-height: 16px;
      color: #fff;
    }
  }
  .close-btn{
    width: 223px;
    height: auto;
    margin-top: 24px;
  }
}
</style>